import { render, staticRenderFns } from "./attach-contact.vue?vue&type=template&id=ed2b3f78&"
import script from "./attach-contact.vue?vue&type=script&lang=js&"
export * from "./attach-contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/attach-contact.vue
// module id = 1684
// module chunks = 0